import { initApi, setImpersonationSessionIdProvider } from '@repo/api'
import { initHereApi } from '@repo/external-api/here'

import { env } from '@/lib/env'
import { useImpersonationStore } from '@/store/impersonation-store'

initApi({ baseUrl: env.VITE_API_BASE_URL })
initHereApi(env.VITE_HERE_API_KEY)

setImpersonationSessionIdProvider(
  () => useImpersonationStore.getState().sessionId,
)
